{
    "action__edit_all": "Edit all",
    "action__cancel_edit_all": "Cancel",
    "action__save_edit_all": "Save",
    "action__mark_customer_as_inactive": "Deactivate",
    "action__mark_customer_as_active": "Activate",
    "analysis__title": "Analysis",
    "analysis__show_more_one": "{{count}} more",
    "analysis__show_more_other": "{{count}} more",
    "mark_inactive_dialog__title": "Mark customer as inactive?",
    "mark_inactive_dialog__bullet_recommendations": "AI recommendations for this customer will stop",
    "mark_inactive_dialog__bullet_recommendations_tooltip": "Sales recommendations are no longer shown for this customer.",
    "mark_inactive_dialog__bullet_plato_only": "This change only affects Plato",
    "mark_inactive_dialog__bullet_plato_only_tooltip": "Your ERP remains unaffected.",
    "mark_inactive_dialog__bullet_reversible": "You can set the customer to active again at any point",
    "mark_inactive_dialog__reason_label": "Reason",
    "mark_inactive_dialog__reason_business_closed": "Business closed",
    "mark_inactive_dialog__reason_merged_accounts": "Merged accounts",
    "mark_inactive_dialog__reason_other": "Other",
    "mark_inactive_dialog__reason_other_placeholder": "Describe the reason",
    "mark_inactive_dialog__success_toast_title": "Customer marked as inactive",
    "mark_inactive_dialog__success_toast_description": "Recommendations paused.",
    "mark_active_dialog__title": "Mark customer as active?",
    "mark_active_dialog__bullet_recommendations": "This will enable AI recommendations for this customer again",
    "mark_active_dialog__bullet_plato_only": "This change only affects Plato",
    "mark_active_dialog__bullet_plato_only_tooltip": "Your ERP remains unaffected.",
    "mark_active_dialog__reason_label": "Reason",
    "mark_active_dialog__reason_resumed_operations": "Resumed operations",
    "mark_active_dialog__reason_other": "Other",
    "mark_active_dialog__reason_other_placeholder": "Describe the reason",
    "mark_active_dialog__success_toast_title": "Customer reactivated",
    "mark_active_dialog__success_toast_description": "Recommendations return tomorrow.",
    "navigation_tab__activities": "Activities",
    "navigation_tab__analysis": "Sales Reports",
    "navigation_tab__info": "Customer Data",
    "glance__title": "At a glance",
    "stats__decoration_gm": "GM",
    "stats__decoration_order_sum": "Order Sum",
    "stats__decoration_revenue": "Revenue",
    "stats__ytd_label": "YTD {{year}}",
    "stats__activities_stats_label": "Activities stats",
    "stats__open_orders": "Open Orders",
    "stats__open_quotes": "Open Quotes",
    "tab_title__contacts": "Contacts",
    "tab_title__addresses": "Ship to Addresses",
    "credit__title": "Credit used",
    "customer_detail__header__new_activity": "New Activity",
    "customer_detail__header__task": "New Task",
    "customer_detail__header__draft": "New Draft",
    "customer_detail__timeline": "Activities",
    "customer_detail__past_activities": "Past",
    "customer_detail__all_activities": "All",
    "customer_detail__tasks": "Tasks",
    "customer_detail__notes": "Interactions",
    "customer_detail__insight_outcomes": "Insight Outcomes",
    "activity_feed__filter_users": "Users",
    "activity_feed__filter_customers": "Customers",
    "customer_detail__status_changes": "Status changes",
    "customer_detail__marked_inactive": "Customer marked inactive",
    "customer_detail__marked_active": "Customer marked active",
    "customer_detail__open_tasks": "Open",
    "customer_detail__completed_tasks": "Completed",
    "customer_detail__quotes": "Quotes",
    "customer_detail__orders": "Orders",
    "status_description_new_with_orders": "This customer placed their first order {{daysSinceFirstOrder}}.",
    "status_description_new_no_orders": "This customer has not placed any orders yet.",
    "status_description_active": "This customer orders regularly and is well engaged.",
    "status_description_at_risk_with_churn": "This customer stopped ordering in their regular rhythm.",
    "status_description_at_risk_revenue_decline": "This customer’s revenue has declined by {{revenueDeclinePercent, number}} over the last 12 months.",
    "status_description_dormant": "This customer hasn’t ordered in over {{monthsSinceLastOrder}} months.",
    "status_description_inactive_reason": "This customer was manually marked as inactive.",
    "status_description_blocked": "This customer is blocked in the ERP. Its status can't be changed in Plato.",
    "field_label__address__canReceiveGoodsAtNight": "Late delivery possible",
    "field_label__address__canReceiveParcels": "Parcel delivery possible",
    "field_label__address__isPreferredShippingAddress": "Preferred delivery address",
    "field_label__address__comment": "Comment",
    "field_label__address__preset__address_formatted": "Address",
    "field_label__contact__birthday": "Birthday",
    "field_label__contact__comment": "Comment",
    "field_label__contact__department": "Department",
    "field_label__contact__email": "Email",
    "field_label__contact__fax": "Fax",
    "field_label__contact__firstName": "First name",
    "field_label__contact__lastName": "Last name",
    "field_label__contact__mobile": "Mobile",
    "field_label__contact__name": "Name",
    "field_label__contact__phone": "Phone",
    "field_label__contact__role": "Role",
    "field_label__contact__salutation": "Salutation",
    "field_label__customer__annualSalesPotential": "Yearly potential",
    "field_label__customer__associationMemberships": "Association memberships",
    "field_label__customer__branch": "Branch",
    "field_label__customer__customerType": "Customer type",
    "field_label__customer__dunningLevel": "Dunning level",
    "field_label__customer__emailAddress": "Email",
    "field_label__customer__employeeCount": "Employee count",
    "field_label__customer__facebookUrl": "Facebook",
    "field_label__customer__faxNumber": "Fax",
    "field_label__customer__firstOrderDate": "First order",
    "field_label__customer__industrySector": "Industry",
    "field_label__customer__lastOrderDate": "Last order",
    "field_label__customer__linkedInUrl": "LinkedIn",
    "field_label__customer__openOrderCount": "Open orders",
    "field_label__customer__openQuoteCount": "Open quotes",
    "field_label__customer__orderBlock": "Order block",
    "field_label__customer__overdueInvoiceCount": "Overdue invoices",
    "field_label__customer__ownExhibition": "Own exhibition",
    "field_label__customer__paymentTerms": "Payment terms",
    "field_label__customer__phoneNumber": "Phone",
    "field_label__customer__potentialReachedTtm": "Potential reached (12M)",
    "field_label__customer__potentialReachedYtd": "Potential reached (YTD)",
    "field_label__customer__preset__customer_address": "Address",
    "field_label__customer__preset__customer_creditLimit": "Credit limit",
    "field_label__customer__preset__customer_externalSalesReps": "Outside rep",
    "field_label__customer__preset__customer_gridCreditLimit": "Credit limit",
    "field_label__customer__preset__customer_internalSalesReps": "Inside rep",
    "field_label__customer__priceGroup": "Price group",
    "field_label__customer__quoteWinRateTtm": "Won / All Quotes L12M",
    "field_label__customer__region": "Region",
    "field_label__customer__revenueTtm": "Revenue last 12 months",
    "field_label__customer__revenueYtd": "Revenue year to date",
    "field_label__customer__taxNumber": "Tax number",
    "field_label__customer__totalOrderCount": "Number of orders",
    "field_label__customer__unbilledLineItemTotal": "Unbilled lines",
    "field_label__customer__websiteUrl": "Website",
    "tab__customer__accounting": "Accounting",
    "tab__customer__general": "General",
    "tab__customer__sales": "Sales",
    "save_error": "Error saving values",
    "save_successful": "Values saved successfully",
    "address_edit__modal_title": "Edit address",
    "address_edit__modal_subtitle": "This record is visible for everyone",
    "address_edit__action__save": "Save",
    "contact_edit__modal_title": "Edit contact",
    "contact_edit__modal_subtitle": "This record is visible for everyone",
    "contact_edit__action__save": "Save",
    "field_placeholder__contact__birthday": "01.01.1980",
    "field_placeholder__contact__comment": "Enter comment",
    "field_placeholder__contact__department": "Enter department",
    "field_placeholder__contact__email": "m.mustermann@email.de",
    "field_placeholder__contact__mobile": "030 2035339",
    "field_placeholder__contact__name": "Max Mustermann",
    "field_placeholder__contact__phone": "030 2035339",
    "field_placeholder__contact__role": "Enter role",
    "field_placeholder__contact__salutation": "Enter salutation",
    "field_placeholder__contact__title": "Dr.",
    "field_placeholder__day": "Day",
    "field_placeholder__month": "Month",
    "field_placeholder__year_optional": "Year (optional)",
    "field_option__year_unknown": "Unknown"
}
